import { useState, useEffect } from 'react';


export type ViewMode = 'default' | 'high-contrast';

export const useTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('theme-mode');
      return saved ? JSON.parse(saved) : false;
    }
    return false;
  });

  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('view-mode');
      return (saved as ViewMode) || 'default';
    }
    return 'default';
  });

  useEffect(() => {
    localStorage.setItem('theme-mode', JSON.stringify(isDarkMode));
    document.documentElement.classList.toggle('dark', isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    localStorage.setItem('view-mode', viewMode);
    document.body.setAttribute('data-view-mode', viewMode);
  }, [viewMode]);

  const toggleTheme = () => setIsDarkMode(prev => !prev);
  const toggleViewMode = () => setViewMode(prev => prev === 'default' ? 'high-contrast' : 'default');

  return { isDarkMode, setIsDarkMode, toggleTheme, viewMode, setViewMode, toggleViewMode };
};
